<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        changeRequestId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isActive: false,
            items: [],
            columns: [
                {
                    text: t('patients::grid.label.field'),
                    value: 'field',
                    sortable: false,
                    width: 100,
                },
                {
                    text: t('patients::grid.label.old_value'),
                    value: 'old_value',
                    width: 150,
                    sortable: false,
                },
                {
                    text: t('patients::grid.label.new_value'),
                    value: 'new_value',
                    width: 150,
                    sortable: false,
                },
            ],
        };
    },
    computed: {
        fieldsToOptionsMapping() {
            return {
                pharmacy_site: this.$store.state.patients.pharmaciesOptions.map((x) => ({ value: x.id, text: x.name })),
                consultant: this.$store.state.patients.consultantsOptions.map((x) => ({ value: x.id, text: x.name })),
                collection_centre: this.$store.state.patients.collectionCentresOptions.map((x) => ({
                    value: x.id,
                    text: x.name,
                })),
            };
        },
    },
    watch: {
        show() {
            this.isActive = this.show;

            if (this.show) {
                this.loadChangeRequest();
            }
        },
    },
    methods: {
        getSelectItem(items, value) {
            return items.find((x) => x.value === value) ? items.find((x) => x.value === value).text : null;
        },
        loadChangeRequest() {
            axios({
                method: 'get',
                url: route('api.v1.requests.show', { id: this.changeRequestId }),
            })
                .then((success) => {
                    this.items = Object.keys(success.data.data.old_values).map((key) => ({
                        field: key,
                        old_value: this.fieldsToOptionsMapping[key]
                            ? this.getSelectItem(this.fieldsToOptionsMapping[key], success.data.data.old_values[key])
                            : success.data.data.old_values[key],
                        new_value: this.fieldsToOptionsMapping[key]
                            ? this.getSelectItem(this.fieldsToOptionsMapping[key], success.data.data.new_values[key])
                            : success.data.data.new_values[key],
                    }));
                })
                .catch((error) => {
                    this.$root.notify('error', error.response.data.error);
                });
        },
    },
};
</script>

<template>
    <v-dialog v-model="isActive" width="820px" @click:outside="$emit('close')">
        <v-card>
            <v-card-title>
                {{ t('patients::dialog.title.change_request') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    :headers="columns"
                    :hide-default-footer="true"
                    :items="items"
                    :items-per-page="-1"
                    fixed-header
                ></v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<style scoped></style>
